<script setup>
import { useDocument } from '@/composables/useDocument'
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'create',
    subject: 'Document',
  },
})

const route = useRoute('document-create')
const router = useRouter()
const { saving, createDraft } = useDocument()

// ?category_id= dipakai pages/governance/sk & kebijakan/index.vue supaya
// tombol "Buat SK"/"Buat Kebijakan" langsung mengarahkan kategorinya,
// tanpa duplikasi form/halaman create Document (Module 14, §9.1). ?title=
// dipakai components/Ai/DraftPreviewCard.vue (Module 22, §29.1) supaya
// "AI Draft SOP" benar-benar "mengisi form Document Engine" seperti
// literal blueprint — user tetap harus klik Simpan di form NORMAL ini,
// AI tidak pernah menulis dokumen secara langsung (BR-012).
const form = ref({
  document_category_id: route.query.category_id ? Number(route.query.category_id) : null,
  unit_id: null,
  title: route.query.title ? String(route.query.title) : '',
})

const errors = ref({})

const save = async () => {
  errors.value = {}
  try {
    const document = await createDraft(form.value)

    router.push({ name: 'document-id', params: { id: document.id } })
  } catch (e) {
    if (e?.status === 422) errors.value = e?.data?.errors ?? {}
    else console.error('Create document error:', e)
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Buat Dokumen
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Dokumen baru dimulai sebagai draft — nomor dokumen dibuat otomatis sesuai format kategori (§25)
    </p>

    <VCard max-width="640">
      <VCardText class="pa-6">
        <VRow>
          <VCol cols="12">
            <MasterDataPicker
              v-model="form.document_category_id"
              entity="document-categories"
              label="Kategori Dokumen *"
              :error-messages="errors.document_category_id"
            />
          </VCol>
          <VCol
            v-if="form.document_category_id"
            cols="12"
            class="mt-n4"
          >
            <DocumentNumberPreview :category-id="form.document_category_id" />
          </VCol>
          <VCol cols="12">
            <MasterDataPicker
              v-model="form.unit_id"
              entity="units"
              label="Unit Pemilik *"
              :error-messages="errors.unit_id"
            />
          </VCol>
          <VCol cols="12">
            <VTextField
              v-model="form.title"
              label="Judul Dokumen *"
              :error-messages="errors.title"
              autofocus
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          variant="tonal"
          color="secondary"
          :disabled="saving"
          @click="router.push({ name: 'document' })"
        >
          Batal
        </VBtn>
        <VBtn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Simpan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
